<svelte:options accessors/>
<script>
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import NauiInput from "../../../naui/atoms/NauiInput.svelte";
    import NauiTextarea from "../../../naui/atoms/NauiTextarea.svelte";

    export let data;
</script>
<div>
    <fieldset>
        <legend>INFORMACIÓN DESISTE</legend>
        <div class="grid-3 gap-15">
            <NauiCheckbox label="Autosolución"
                          disabled={true}
                          value={data.autosolucion}/>
            <NauiCheckbox label="Competencia"
                          disabled={true}
                          value={data.competencia}/>
            <NauiCheckbox label="Disponibilidad"
                          disabled={true}
                          value={data.disponibilidad}/>
            <NauiCheckbox label="No interesado"
                          disabled={true}
                          value={data.no_interesado}/>
            <NauiCheckbox label="Precio"
                          disabled={true}
                          value={data.precio}/>
            <NauiCheckbox label="Reporte"
                          disabled={true}
                          value={data.reporte}/>
            <NauiCheckbox label="Tamaño"
                          disabled={true}
                          value={data.tamano}/>
            <NauiCheckbox label="Ubicación"
                          disabled={true}
                          value={data.ubicacion}/>
        </div>
        <div class="grid-3 gap-15">
            <NauiCheckbox label="Otro"
                          disabled={true}
                          value={data.otro}/>

            <NauiInput label="¿Cuál?"
                       bind:value={data.detalle_otro}
                       isDisabled={true}/>
        </div>
        <NauiTextarea label="Observaciones"
                      isDisabled={true}
                      bind:value={data.observaciones}/>
    </fieldset>
</div>